/**
 * MarketBoomWidget — 08/02/2026 (Q2 Lot D user prod).
 *
 * Affiche le boom sectoriel actif (event evt-marche-03, choix « Saisir »).
 * Montre le secteur en boom, le multiplicateur +20 % et le countdown
 * jusqu'à l'expiration. Caché si aucun boom n'est actif.
 *
 * User request : « Boom sectoriel — Pas tangible. Quel secteur ? Quelle
 * durée ? Quel impact ? ». Le widget répond aux 3 questions.
 */
import React from 'react';
import useGameStore from '../../store/gameStore';
import { Rocket, Calendar } from 'lucide-react';

export default function MarketBoomWidget() {
  const boom = useGameStore(s => s.marketBoom);
  const totalDays = useGameStore(s => s.totalDays || 0);
  const active = !!(boom && boom.endDay > totalDays);
  if (!active) return null;
  const daysLeft = Math.max(0, boom.endDay - totalDays);
  const boostPct = Math.round((boom.revenueBoost || 0.20) * 100);

  return (
    <div
      className="rounded-lg border border-amber-400/50 bg-gradient-to-r from-amber-500/10 to-orange-500/10 px-3 py-2 flex items-center gap-3 group relative"
      data-testid="market-boom-widget"
      title={`Boom sectoriel : ${boom.label} — +${boostPct} % revenu pendant ${daysLeft} jour(s)`}
    >
      <Rocket className="w-5 h-5 text-amber-400 shrink-0" />
      <div className="flex flex-col">
        <span className="text-[10px] uppercase tracking-wider text-amber-300 font-mono font-bold">
          Boom sectoriel
        </span>
        <span className="text-sm font-black text-amber-100 leading-tight" data-testid="market-boom-label">
          {boom.label}
        </span>
        <span className="text-[10px] text-amber-200/80 font-mono">
          <span data-testid="market-boom-boost">+{boostPct} %</span> sur contrats secteur
        </span>
      </div>
      <div className="ml-auto flex items-center gap-1 text-amber-200/90">
        <Calendar className="w-3 h-3" />
        <span className="text-xs font-mono font-bold" data-testid="market-boom-days-left">
          {daysLeft} j
        </span>
      </div>
    </div>
  );
}
